module.exports = typeof window == 'object' && typeof Deno != 'object';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-browser.js
// module id = 1078
// module chunks = 0